module.exports = __webpack_public_path__ + "media/images/flags/bn-5be7f9740d57aef03866f81e2ccc572c.svg";